<!-- 2026-10-18：按用户要求暂时隐藏语言设置入口，保留翻译与已保存的语言偏好。 -->
<!-- 2026-10-18：登录页及移动菜单提供键盘可用的三语切换，保留表单与当前页面。 -->
<template>
  <select v-if="false" class="ui-language-select" aria-label="Language / ئۇيغۇرچە / 中文" :value="language" @change="change" data-i18n-ignore>
    <option value="zh">简体中文</option>
    <option value="en">English</option>
    <option value="ug">ئۇيغۇرچە</option>
  </select>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import { displayLanguage, normalizeLanguage } from './display'
export default defineComponent({
  setup() {
    const store = useStore(), i18n = useI18n()
    const change = (event: Event) => {
      const value = normalizeLanguage((event.target as HTMLSelectElement).value)
      store.commit('app/changeLanguage', value)
      i18n.locale.value = value
    }
    return { language: displayLanguage, change }
  }
})
</script>
<style scoped>
.ui-language-select {max-width:100%;min-height:36px;padding:4px 8px;border:1px solid #cbd5e1;border-radius:6px;background:#fff;color:#1f2937;font:inherit;direction:ltr;}
</style>
